<template lang="pug">
  .bannerBlock.w-full.h-96.bg-grey-33.px-20.min-w-1024(v-if="show")
    .max-w-1366.flex.items-center.justify-between.m-auto.h-full
      slot(:name="slotName" )
      .flex(v-if="showBTN")
        Button.mr-24.w-180(:text="$t('__cookiesBanner.__cookieSetting')"  :type="'ada'" 
          @buttonClick='clickBanner')
        Button.w-180(:text="$t('__cookiesBanner.__acceptCookies')"  :type="'btn'" 
          @buttonClick='clickBanner2' v-if="showBTN2")
      
    
</template>

<script>
import Button from "@/components/Button.vue";

export default {
  name: "Banner",
  components: {
    Button
  },
  props: {
    show: {
      type: Boolean,
      required: true,
      default: false
    },
    slotName: String,
    showBTN: {
      type: Boolean,
      default: true
    },
    showBTN2: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {};
  },
  mounted() {},
  methods: {
    clickBanner() {
      this.$emit("clickBanner", false);
    },
    clickBanner2() {
      this.$emit("clickBanner2", false);
    }
  },
  watch: {}
};
</script>

<style lang="scss" scoped></style>
